var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.76732V3.23398C14.6667 2.23398 14.24 1.83398 13.18 1.83398H10.4867C9.42667 1.83398 9 2.23398 9 3.23398V7.76732C9 8.76732 9.42667 9.16732 10.4867 9.16732H13.18C14.24 9.16732 14.6667 8.76732 14.6667 7.76732Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 13.766V12.566C14.6667 11.566 14.24 11.166 13.18 11.166H10.4867C9.42667 11.166 9 11.566 9 12.566V13.766C9 14.766 9.42667 15.166 10.4867 15.166H13.18C14.24 15.166 14.6667 14.766 14.6667 13.766Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 9.23398V13.7673C7.00001 14.7673 6.57334 15.1673 5.51334 15.1673H2.82001C1.76001 15.1673 1.33334 14.7673 1.33334 13.7673V9.23398C1.33334 8.23398 1.76001 7.83398 2.82001 7.83398H5.51334C6.57334 7.83398 7.00001 8.23398 7.00001 9.23398Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 3.23398V4.43398C7.00001 5.43398 6.57334 5.83398 5.51334 5.83398H2.82001C1.76001 5.83398 1.33334 5.43398 1.33334 4.43398V3.23398C1.33334 2.23398 1.76001 1.83398 2.82001 1.83398H5.51334C6.57334 1.83398 7.00001 2.23398 7.00001 3.23398Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.319a4ef6.svg";
export { ForwardRef as ReactComponent };